import { en } from "../locales/en";
import { DashboardMenubar } from "../components/menubar/menubar";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import ErrorLogService from "../services/error-log/error-log.service";
import { useSetPageTitle } from "../hooks/useSetPageTitle";
import PageEmptyState from "../components/page-empty-state/page-empty-state";
import { AppLayout } from "../components/layout/app-layout";
import { shouldUseNewLayout } from "../helpers/layout.helpers";
import { useSelector } from "react-redux";
import { RootState } from "../redux/redux-store";

const { title, button } = en.four04;

const Four04 = () => {
  useSetPageTitle('Page not found');
  const navigate = useNavigate();
  const location = useLocation();
  const [, setSearchParams] = useSearchParams();
  const { clientId } = useParams<{ clientId?: string }>();
  const userState = useSelector((state: RootState) => state.userState);
  const useNewLayout = shouldUseNewLayout(userState.permissions);

  useEffect(() => {
    setSearchParams({ '404': 't' });
    ErrorLogService.logError(new Error('404 page not found'), '404.tsx', 'mount', [location]);
  }, []);

  function handleBackToDashboard() {
    if (clientId || userState.activeClient) {
      navigate(`/client/seats`);
    } else {
      navigate('/surveys');
    }
  }

  // Legacy layout for client users
  if (!useNewLayout) {
    return (
      <div className="flex min-h-screen w-full flex-col">
        <DashboardMenubar bgColorClass="!justify-end" />
        <PageEmptyState
          buttonText={button}
          onButtonClick={handleBackToDashboard}
          title={title}
        />
      </div>
    );
  }

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/404"
      navbarProps={{
        // title: "Page Not Found",
      }}
    >
      <div className="flex justify-center items-center min-h-[60vh]">
        <PageEmptyState
          buttonText={button}
          onButtonClick={handleBackToDashboard}
          title={title}
        />
      </div>
    </AppLayout>
  );
};

export default Four04;
